/** The connection request frame: connect an app from the canvas. */
export default {
  // Setup
  connectApps: { one: "Connect an app", other: "Connect {count} apps" },
  allConnected: { one: "App connected", other: "All {count} apps connected" },
  connectedTo: "Connected to {app}",
  finishInBrowser: "Finish connecting in the browser to continue.",
  loadOptionsFailed: "Could not load connection options.",
  stillCompleting: "Your connection is still being completed.",
  checkStatus: "Check status",
  useDifferentCredentials: "Use different credentials",
  checkConnectionStatus: "Check connection status",
  connect: "Connect",
  opensBrowserToSignIn: "Opens your browser to sign in.",
  connecting: "Connecting…",

  // Errors
  credentialsRejected:
    "The credentials were not accepted. Check the key and permissions, then try again.",
  checkKeyFields:
    "Check the key, required fields and permissions, then try again.",
  connectFailed:
    "Could not complete the connection. Check connection status before trying again.",
  checkFailed: "Could not check the connection. Please try again.",
  cancelPreviousFailed:
    "Could not cancel the previous connection. Please try again.",

  // Credential form
  apiKeyInstructions: "Create an API key in your account, then paste it below.",
  openApiKeys: "Open {app} API keys",
  openPageFailed: "Could not open the page. Try again.",
  optionalField: "{label} (optional)",
  chooseOption: "Choose an option",
} as const;
